export default {

  namespaced: true,

  state: () => ({


  }),

  mutations: {

  },

  actions: {

    async getLastNotifications({ commit }, params ) {
      let response = await axios.get("/erp/notification/notification", { params : { page : 1, limit : 4 } })

      return response.data
    },
    
    async getNotifications({ commit }, params ) {
      let response = await axios.get("/erp/notification/notification", { params : params })

      return response.data.notifications
    },

    async markAsRead({ dispatch, commit }) {
      await axios.post("/erp/notification/notification")
    }

  }
}
